import noop from 'lodash-es/noop';

import type { AppDispatch } from '@jane/monolith/customer/redux';
import {
  showErrorNotification,
  showSuccessNotification,
} from '@jane/monolith/customer/redux/notifications';
import { postMessageToIframeParent } from '@jane/shared/util';

let dispatch: AppDispatch = noop as AppDispatch;

export const setNotificationsDispatch = (newDispatch: AppDispatch) => {
  dispatch = newDispatch;
};

export const NotificationsService = {
  success: (message: string) => {
    dispatch(showSuccessNotification(message));
  },
  error: (errorOrMessage: string | Error) => {
    const message =
      typeof errorOrMessage === 'string'
        ? errorOrMessage
        : 'Something went wrong';
    dispatch(showErrorNotification(message));
  },
  notifyErrorToIFrameParent: (error: any, source: any, messageType: any) => {
    postMessageToIframeParent({
      messageType,
      payload: {
        name: messageType,
        properties: {
          error,
          source,
        },
      },
    });
  },
};
